module.exports = __webpack_public_path__ + "static/media/cupcake.4cee5b3f.svg";